export const MAIN_COLOR_TAB_OPTIONS = { 
  IN_USE: 1,
  SOLIDS: 2, 
  PATTERNS: 3
}